import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';

import { SeatUpgradeDialog } from '@/components/billing/seat-upgrade-dialog';
import { PageHeader } from '@/components/shared/page-header';
import { api } from '@/lib/api';

import { SubscriptionsSectionNav } from './subscriptions-section-nav';
import { SubscriptionsSummaryStrip } from './subscriptions-summary-strip';
import type { ReferralSummary, SubscriptionsSummary } from './subscriptions-types';
import { useSubscriptionsCheckoutReturn } from './use-subscriptions-checkout-return';

export const SubscriptionsLayout = () => {
  const { t } = useTranslation('billing');
  const [seatUpgradeOpen, setSeatUpgradeOpen] = useState(false);
  useSubscriptionsCheckoutReturn();

  const summary = useQuery({
    queryKey: ['billing-summary'],
    queryFn: () => api.get<SubscriptionsSummary>('/billing/summary'),
  });

  const referral = useQuery({
    queryKey: ['billing-referral'],
    queryFn: () => api.get<ReferralSummary>('/billing/referral'),
  });

  return (
    <div className="space-y-6">
      <PageHeader title={t('title')} description={t('description')} />

      <SubscriptionsSummaryStrip
        data={summary.data}
        loading={summary.isLoading}
        onAddSeat={() => setSeatUpgradeOpen(true)}
      />

      <SeatUpgradeDialog open={seatUpgradeOpen} onOpenChange={setSeatUpgradeOpen} />

      <div className="flex flex-col gap-6 lg:flex-row lg:items-start">
        <SubscriptionsSectionNav />
        <div className="min-w-0 flex-1">
          <Outlet
            context={{
              summary: summary.data,
              summaryLoading: summary.isLoading,
              referral: referral.data,
            }}
          />
        </div>
      </div>
    </div>
  );
};
